// oxlint-disable react/only-export-components -- barrel: Toast type + store re-exports + ToastAreaRoot.
import * as React from 'react';

import type {ToastType} from 'common/components/toast/types';
import {LocaleSafeString, StrictTranslatable} from 'common/i18n';

import {ToastAreaReact} from './toast-area-content';
import {toastStore} from './toast-store';

export {DEFAULT_TOAST_TTL, toastStore} from './toast-store';
export {ToastAreaReact} from './toast-area-content';

export interface Toast {
  id?: number;
  type?: ToastType;
  cta?: string;
  ctaHref?: string;
  ctaTarget?: string;
  ctaCallback?: () => void;
  closeToastCallback?: () => void;
  undoCallback?: () => void;
  elref?: string;
  hide?: boolean;
  hideCancelButton?: boolean;
  isError?: boolean;
  undoable?: boolean;
  undoLabel?: string;
  timeout?: number;
  isStatic?: boolean;
  persistent?: boolean;
  ttl?: number;
  message: StrictTranslatable | LocaleSafeString | React.ReactNode;
}

export function ToastAreaRoot(): React.ReactElement {
  const toasts = React.useSyncExternalStore(toastStore.subscribe, toastStore.getSnapshot, toastStore.getSnapshot);
  return (
    <ToastAreaReact
      toasts={toasts}
      onAction={(t) => {
        t.ctaCallback?.();
        toastStore.close(t);
      }}
      onClose={(t) => {
        t.closeToastCallback?.();
        toastStore.close(t);
      }}
      onUndo={(t) => {
        t.undoCallback?.();
        toastStore.close(t);
      }}
    />
  );
}
